export default __webpack_public_path__ + "static/media/topicanalytics_icon.ab869663.svg";